// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/root.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$(),
  _s2 = $RefreshSig$(),
  _s3 = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/root.tsx");
}
// REMIX HMR END

import { cssBundleHref } from "@remix-run/css-bundle";
import { json, Links, Meta, Outlet, Scripts, ScrollRestoration, useLoaderData, useParams, isRouteErrorResponse, useRouteError } from "@remix-run/react";
import { useContext

//, useEffect, useState 
} from "react";
import { getThemeSession } from "./utils/sessions/theme.server";
import { NonFlashOfWrongThemeEls, ThemeProvider, useTheme } from "./utils/provider/theme-provider";
import { LangProvider } from "./utils/provider/lang-provider";
import { langByParam } from "./utils/lang";
import { NonceContext } from "./utils/provider/NonceContext";
import stylesRoot from './styles/index.css';
import HeaderComp from "./components/header/HeaderComp";
import Footer from "./components/footer/Footer";
import SYS_CONFIG from "./config";
export function ErrorBoundary() {
  _s();
  const error = useRouteError();
  if (isRouteErrorResponse(error)) {
    return <div>

        <main className="page_1">
          <h1>
            {error.status} {error.statusText}
          </h1>
          <p>{error.data}</p>
        </main>
      </div>;
  } else if (error instanceof Error) {
    return <main className="page_1">
        <h1>Error</h1>
        <p>{error.message}</p>
      </main>;
  } else {
    return <div>
        <main className="page_1">
          <h1>Unknown Error</h1>
        </main>
      </div>;
  }
}
_s(ErrorBoundary, "oAgjgbJzsRXlB89+MoVumxMQqKM=", false, function () {
  return [useRouteError];
});
_c = ErrorBoundary;
export const links = () => [...(cssBundleHref ? [{
  rel: "stylesheet",
  href: cssBundleHref
}] : []), {
  rel: "stylesheet",
  href: stylesRoot
}];
export const loader = async ({
  request
}) => {
  const themeSession = await getThemeSession(request);
  return json({
    theme: themeSession.getTheme()
  });
};
function App() {
  _s2();
  const cspNonce = useContext(NonceContext);
  const [theme] = useTheme();
  const data = useLoaderData();
  const {
    lang
  } = useParams();
  const langObj = langByParam(lang);
  const {
    URL_SITE_DOMAIN
  } = SYS_CONFIG;

  /*
    const [isLoaded, setIsLoaded] = useState(false)
  
  
    useEffect(() => {
      setIsLoaded(true)
  
      //   (function (oqta) {
      //     const d = document,
      //       s = d.createElement('script'),
      //       l = d.scripts[d.scripts.length - 1];
      //     s.settings = oqta || {};
      //     // https://welltodo-type.com/bL3bVO0.PQ3dplvLb/mlVKJ/ZZDR0R1pNjjrQu0WMtTxE/w/LOTkU/2uNYDUQEx/MGT/E-
      //     s.src = "https://welltodo-type.com/c.D/9u6/bb2i5xlRSFW/QT9/N/TOY/0INVDDEqx_MDCS0K1AN/j/QO0UM/TUEyxh";
      //     s.async = true;
      //     s.nonce = cspNonce
      //     s.referrerPolicy = 'no-referrer-when-downgrade';
      //     if (l?.parentNode) l.parentNode.insertBefore(s, l);
      //   })({})
  
    }, []);
  
  //         <script nonce={cspNonce} type="text/javascript"> var infolinks_pid = 3427205; var infolinks_wsid = 0; </script>
  
    // <script type="text/javascript"> var infolinks_pid = 3427205; var infolinks_wsid = 0; </script>
    // <script type="text/javascript" src="//resources.infolinks.com/js/infolinks_main.js"></script>
  
    if (isLoaded && !document.getElementById("adsbygoogleaftermount")) {
      const headTag = document.querySelector("head");
      const scriptTag = document.createElement("script");
      if (headTag) {
        scriptTag.setAttribute(
          "src",
          "//resources.infolinks.com/js/infolinks_main.js"
          // 'https://welltodo-type.com/bL3bVO0.PQ3dplvLb/mlVKJ/ZZDR0R1pNjjrQu0WMtTxE/w/LOTkU/2uNYDUQEx/MGT/E-'
          // 'https://alwingulla.com/88/tag.min.js'
          // "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-8548296639453865"
        );
  
        scriptTag.id = 'adsbygoogleaftermount'
        //scriptTag.setAttribute("crossorigin", "anonymous");
        //  scriptTag.setAttribute("async", "true");
        // scriptTag.type = "text/javascript"
        // scriptTag.setAttribute("referrerPolicy", "no-referrer-when-downgrade");
        // scriptTag.setAttribute("data-zone", '107828')
        // scriptTag.setAttribute("data-cfasync", "false")
        scriptTag.setAttribute('nonce', cspNonce)
        //@ts-expect-error adfadf
        window.infolinks_pid = 3427205
              //@ts-expect-error adfadf
        window.infolinks_wsid = 0
  
        //   document.head.appendChild(script);
  
  
        headTag.appendChild(scriptTag);
  
      }
    }
  
  
  */

  // <script src="https://alwingulla.com/88/tag.min.js" data-zone="107828" async data-cfasync="false"></script>

  /**
   * <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-8548296639453865"
       crossorigin="anonymous"></script>
   */

  //         <script src="https://alwingulla.com/88/tag.min.js" data-zone="107828" async data-cfasync="false"></script>

  return <html lang={langObj.lang_html} className={theme ?? ''} itemScope itemType="http://schema.org/WebSite">
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        {/**
          *         <meta name="viewport" content="width=device-width, height=device-height, initial-scale=1, maximum-scale=1.0, user-scalable=0" />
          */}

        <link rel="preload" as="font" href={`${URL_SITE_DOMAIN}/_static/fonts/Prompt-Light.woff2`} type="font/woff2" crossOrigin="anonymous" />
        <link rel="icon" href={`${URL_SITE_DOMAIN}/_static/favicon.ico`} />
        <Meta />
        <Links />
        <NonFlashOfWrongThemeEls nonce={cspNonce} ssrTheme={Boolean(data.theme)} />
        <meta name="robots" content="max-image-preview:large" />
        <meta name="theme-color" content="#0070b4" />
        <link rel="manifest" href={`${URL_SITE_DOMAIN}/_static/site.webmanifest`} />
        <meta itemProp="about" content="Zürich" />
        <meta itemProp="isFamilyFriendly" content="True" />
        <meta itemProp="isAccessibleForFree" content="True" />
        <meta itemProp="accessibilityHazard" content="noSoundHazard" />
        <meta itemProp="accessibilityFeature" content="alternativeText" />
        <meta itemProp="accessibilityControl" content="fullKeyboardControl" />
        <meta itemProp="accessibilityControl" content="fullMouseControl" />
        <meta itemProp="url" content={URL_SITE_DOMAIN} />
        <meta itemProp="name" content="in Zürich" />
        <meta itemProp="alternateName" content="inZH" />
        <meta itemProp="image" content={URL_SITE_DOMAIN + `/_static/icons/logo512x512.png`} />
        <meta name="msvalidate.01" content="6DCCF2846BD9A91B5A8764CF0F5C1E76" />







        {/**
          *         <meta name="a33a814fc7ccc0d7ca4707dfeaf1092fa23c3e5d" content="a33a814fc7ccc0d7ca4707dfeaf1092fa23c3e5d" />
          *         <meta name="monetag" content="df54450225458a680ca49e82fccc4b0a" /> 
          *         <meta name="google-adsense-account" content="ca-pub-8548296639453865" />
          *         <meta name="google-adsense-account" content="ca-pub-8548296639453865" />
          *         <meta name="ezoic-site-verification" content="ZHSY3mNqtRIxzfVIIfWa7N1IoE3SvX" />
          */}


      </head>
      <body itemScope itemType="http://schema.org/WebPage">
        <HeaderComp />
        <Outlet />
        <Footer />
        <ScrollRestoration nonce={cspNonce} />
        <Scripts nonce={cspNonce} />
      </body>
    </html>;
}
_s2(App, "FMJ/aBuS8eInZ9RyqBGyieuCvYw=", false, function () {
  return [useTheme, useLoaderData, useParams];
});
_c2 = App;
export default function AppWithProviders() {
  _s3();
  const data = useLoaderData();
  return <ThemeProvider specifiedTheme={data?.theme}>
      <LangProvider>
        <App />
      </LangProvider>
    </ThemeProvider>;
}
_s3(AppWithProviders, "5thj+e1edPyRpKif1JmVRC6KArE=", false, function () {
  return [useLoaderData];
});
_c3 = AppWithProviders;
var _c, _c2, _c3;
$RefreshReg$(_c, "ErrorBoundary");
$RefreshReg$(_c2, "App");
$RefreshReg$(_c3, "AppWithProviders");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;